import { useShowLocation } from '@givebacks/api/offers';
import { Badge, Group, Stack, Title } from 'ui';

const CashbackAvailableDays = ({ locationId }: { locationId?: string }) => {
  const { data: locationData } = useShowLocation({
    locationId: locationId ?? '',
  });

  const availableSunday = locationData?.offers[0].sunday;
  const availableMonday = locationData?.offers[0].monday;
  const availableTuesday = locationData?.offers[0].tuesday;
  const availableWednesday = locationData?.offers[0].wednesday;
  const availableThursday = locationData?.offers[0].thursday;
  const availableFriday = locationData?.offers[0].friday;
  const availableSaturday = locationData?.offers[0].saturday;

  return (
    <Stack gap="sm">
      <Title order={4}>Cashback Available Days</Title>
      <Group gap="xs">
        {availableSunday && (
          <Badge type="success" variant="outline">
            Sun
          </Badge>
        )}

        {availableMonday && (
          <Badge type="success" variant="outline">
            Mon
          </Badge>
        )}

        {availableTuesday && (
          <Badge type="success" variant="outline">
            Tue
          </Badge>
        )}

        {availableWednesday && (
          <Badge type="success" variant="outline">
            Wed
          </Badge>
        )}

        {availableThursday && (
          <Badge type="success" variant="outline">
            Thu
          </Badge>
        )}

        {availableFriday && (
          <Badge type="success" variant="outline">
            Fri
          </Badge>
        )}

        {availableSaturday && (
          <Badge type="success" variant="outline">
            Sat
          </Badge>
        )}
      </Group>
    </Stack>
  );
};

export { CashbackAvailableDays };
